import { http } from '../../config/axios'

export default function getZipBoletoFaturamento(id: number): Promise<Blob> {
  return http
    .get('api/faturamento/zip-boleto/' + id, {
      responseType: 'blob'
    })
    .then((r) => r.data)
    .then((blobFile) => {
      return blobFile
    })
}
